<template>
    <div class="block-editor google-business-reply-review">
        <section>
            <div class="title">Channel ID</div>
            <TiptapEditor placeholder="Google Business Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>Yanıt verilecek yorumun bulunduğu kanal ID'si</small>
        </section>
        <section>
            <div class="title">Review ID</div>
            <TiptapEditor placeholder="Google Business Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>Yanıt verilecek yorumun ID'si</small>
        </section>
        <section>
            <div class="title">Yanıt Metni</div>
            <TiptapEditor placeholder="Yanıt metni giriniz..." :show-attributes="true" v-model="clone.text" automation-mode />
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleBusinessReplyReview",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                reviewId: "",
                text: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-business-reply-review {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
